import React from 'react'

const SettingHandleCall = ({ className }) => (
  <svg
    width="34px"
    height="46px"
    viewBox="0 0 34 46"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs />
    <g className={className} transform="translate(-87.000000, -37.000000)" fill="#FFFFFF">
      <path d="M88.0296797,37 L119.97271,37 C120.524995,37 120.97271,37.4477153 120.97271,38 C120.97271,38.1162615 120.952436,38.2316325 120.912799,38.3409287 L104.941284,82.3813681 C104.752994,82.9005651 104.179463,83.1688183 103.660266,82.9805286 C103.381619,82.8794756 103.162159,82.6600155 103.061106,82.3813681 L87.0895906,38.3409287 C86.9013009,37.8217318 87.1695542,37.2482005 87.6887511,37.0599108 C87.7980472,37.020274 87.9134182,37 88.0296797,37 Z" />
    </g>
  </svg>

)

export default SettingHandleCall



// WEBPACK FOOTER //
// ./src/components/assets/SettingHandleCall.js